module.exports = __webpack_public_path__ + "static/media/home.601d57df.png";